import { render, staticRenderFns } from "./top20.vue?vue&type=template&id=40ac9a8a&"
import script from "./top20.vue?vue&type=script&lang=js&"
export * from "./top20.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports